import { YT_IFRAME_SCRIPT_URL } from '../contactUs/constants/UtilVariables';

/**
 * Return iframe srcdoc from iframe html element
 * applicable only for iframe having source of videos hosted on paypalobjects
 * @param { object } iframe html element
 * @returns { string } html string
 */
export const getArticleVideoIframeSrcDoc = (iframeElement) => {
  const { height, width, src } = iframeElement;
  return `<html><body style="margin:0;overflow:hidden;"><video width="${width}" height="${height}" controls="true"><source src="${src}" /></video></body></html>`;
};

/**
 * load Youtube Iframe API asynchronously if doesn't exist
 * @returns { boolean } isScriptAlreadyPresent
 */
export const loadYTIframeScript = () => {
  const existingScript = document.getElementById('sh_iframe_api_script');
  if (existingScript) {
    return true;
  }
  const script = document.createElement('script');
  script.id = 'sh_iframe_api_script';
  script.src = YT_IFRAME_SCRIPT_URL;
  script.async = true;
  document.body.appendChild(script);
  return false;
};
